<template>
  <div style="width: 100%;">
  <img src="./4x.png" alt="">

  </div>
  <div
  v-if="false"
    id="printJS-form"
    class="p-2"
    style="
      background: #435285;
      box-shadow: 0px 1px 2px rgba(56, 65, 74, 0.14902);
      border-radius: 4px;
    "
  >
    <!-- 设备健康体检报告抬头 -->
    <div class="d-flex align-items-center justify-content-between" style="border-bottom: 2px solid #fff;padding:30px 20px 10px 20px;">
      <div class="d-flex align-items-end">
        <img
            style="width: 16rem; height: 100%;margin-right:10px"
            src="../../assets/images/examination/NAsh_logo1.png"
            alt=""
        />
        <img
            style="width: 6rem; height: 100%;margin:0 0 5px -15px;"
            src="../../assets/images/examination/iiot.png"
            alt=""
        />
      </div>
      <h1 style="color:#fff;letter-spacing:5px;">设备健康体检报告</h1>
      <div class="d-flex justify-content-between" style="width: 380px;margin-left:6.5%">
        <!-- -->
        <div  v-if="isPrint" class="input-group mt-2">
            <span class="input-group-text"
              ><i class="ri-calendar-2-line"></i
            ></span>
            <flat-pickr  
              
              v-model="selectedMonth"
              id = "mouthYearFlatPickr"
              class="form-control flatpickr-input" 
              placeholder="选择月份"
            ></flat-pickr>
            <span v-if="selectedMonth" @click="clearDate" class="multiselect-clear-icon position-absolute cursor-pointer" style="bottom: 26%; right:1rem;"></span> 
        </div>
      </div>
    </div>
    <!-- 柱状图，评分 -->
    <div class="d-flex mt-2 w-100">
      <div id="chartBox" style="width: calc(100% - 350px)">
        <!-- 设备title -->
        <div class="d-flex justify-content-between" style="font-weight: 700; font-size: 16px; color: #ffffff;padding: 50px 0 0 95px;">
          <div>设备名称：
            <sapn style="border-bottom: 1px solid #fff;">{{ equip_data.name }}</sapn>
          </div>
          <div>设备序列号：
            <sapn style="border-bottom: 1px solid #fff;">{{ equip_data.root_sn }}</sapn>
          </div>
          <div>体检时间：{{ report_data && report_data.report_date }}</div>
        </div>
        <!-- 柱状图 -->
        <div id="examinationChat" style="height: 400px"></div>
      </div>
      <div
        style="width: 360px; padding: 20px"
        class="d-flex flex-wrap justify-content-center"
      >
        <div id="markChart" style="width: 200px; height: 200px"></div>
        <div
          style="
            width: 100%;
            height: 180px;
            margin-bottom: 30px;
            background: #fbfcfe;
            border: 0.5px solid #dde4f0;
            box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
            border-radius: 20px;
          "
          class="d-flex flex-wrap align-content-between justify-content-start p-3"
        >
          <div
            class="w-100"
            style="font-weight: 600; font-size: 16px; color: #000000"
          >
            服务人员联系信息
          </div>
          <div
            class="w-100"
            style="font-weight: 400; font-size: 16px; color: #000000"
          >
            {{ engineer_info.company }}
          </div>
          <div
            class="w-100 d-flex"
            style="font-weight: 400; font-size: 16px; color: #000000"
          >
            <div style="width: 70px">姓名</div>
            <div>{{ engineer_info.name }}</div>
          </div>
          <div
            class="w-100 d-flex"
            style="font-weight: 400; font-size: 16px; color: #000000"
          >
            <div style="width: 70px">联系电话</div>
            <div>{{ engineer_info.tel }}</div>
          </div>
          <div
            class="w-100 d-flex"
            style="font-weight: 400; font-size: 16px; color: #000000"
          >
            <div style="width: 70px">邮箱</div>
            <div>{{ engineer_info.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 故障风险智能预测 -->
    <div class="card">
      <div
        class="card-header border-0"
        style="font-weight: 600; font-size: 16px; color: #212529"
      >
        <img
          style="height: 27px; width: 27px"
          src="../../assets/images/examination/vector.png"
          alt=""
        />
        故障风险智能预测
      </div>
      <div
        style="min-height: 350px"
        class="card-body d-flex justify-content-between position-relative"
      >
        <div
          v-if="risk_prediction && !risk_prediction.enabled"
          style="
            width: 100%;
            height: 100%;
            min-height: 360px;
            background: rgba(73, 87, 135, 0.4);
            position: absolute;
            top: 0;
            left: 0;
            backdrop-filter: blur(10px);
            z-index: 10;
          "
          class="d-flex justify-content-center align-items-center"
        >
          <div
            style="
              width: 454px;
              height: 86px;
              line-height: 86px;
              text-align: center;
              background: rgba(67, 82, 133, 0.8);
              box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
              border-radius: 20px;
              font-weight: 600;
              font-size: 32px;
              color: #ffffff;
            "
          >
            模型训练中
          </div>
        </div>
        
        
        <div
          class="d-flex justify-content-between"
          :style="`width: 65%; border-right: 2px dashed #c3cbcf;
          ${splitIndex > 6&&!isPrint ? ('height:'+splitIndex*48+'px') :''}`"
        >
          <!-- 左侧测点 -->
          <div
            class="w-100"
            :style="`max-height:318px;`"
          >
            <div 
              class=" d-flex flex-wrap justify-content-center align-content-between"
              :class="[isPrint&&'scroll-hidden']"
              :style="`height:100%;${isPrint?'overflow-y: scroll;':''}`">
              <div
                v-for="a in risk_prediction && (splitIndex > 0 ? risk_prediction.data.slice(0, splitIndex):risk_prediction.data)"
                :key="a.fault_name"
                style="width: 75%; min-width: 300px; cursor: pointer"
                class="d-flex flex-wrap justify-content-between align-items-center mb-2"
                v-on:mouseover="selectFaultHandler(a)"
              >
                <div
                  style="
                    width: 238px;
                    height: 38px;
                    background: #FF9500;
                    border-radius: 30px;
                    padding: 0 20px;
                    color: #ffffff;
                  "
                  class="d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <div
                      style="
                        width: 10px;
                        height: 10px;
                        background: #ffffff;
                        border-radius: 50%;
                      "
                    ></div>
                    <div class="ms-2">{{ a.fault_name }}</div>
                  </div>
                  <div>{{ a.level }}</div>
                </div>
                <div style="width: 60px; border-top: 1px solid #000000"></div>
              </div>
            </div>
          </div>
          <div style="margin:auto 0;">
            <!-- 模型图片或动态图片 -->
            <img
              style="width: 354px; height: 317px"
              :src="`${equipImage()}`"
              alt=""
            />
          </div>
          <!-- 右侧测点 -->
          <div
            class="w-100"
            :style="`max-height:318px;`"
          >
            <div 
              class="d-flex flex-wrap justify-content-center align-content-between" 
              :class="[isPrint&&'scroll-hidden']"
              :style="`height:100%;${isPrint?'overflow-y: scroll;':''}`">
              <div
                v-for="a in risk_prediction && (splitIndex>0?risk_prediction.data.slice(splitIndex):[])"
                :key="a"
                style="width: 75%; min-width: 300px"
                class="d-flex flex-wrap justify-content-between align-items-center mb-2"
                v-on:mouseover="selectFaultHandler(a)"
              >
                <div style="width: 60px; border-top: 1px solid #000000"></div>
                <div
                  style="
                    width: 238px;
                    height: 38px;
                    background: #FF9500;
                    border-radius: 30px;
                    padding: 0 20px;
                    color: #ffffff;
                  "
                  class="d-flex justify-content-between align-items-center"
                >
                  <div class="d-flex align-items-center">
                    <div
                      style="
                        width: 10px;
                        height: 10px;
                        background: #ffffff;
                        border-radius: 50%;
                      "
                    ></div>
                    <div class="ms-2">{{ a.fault_name }}</div>
                  </div>
                  <div>{{ a.level }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 知识库建议  -->
        <div
          style="width: 35%; margin: 0 40px 40px 40px; position: relative"
          :style="`${riskPredictionDescLength>4&&!isPrint?('height:'+riskPredictionDescLength*50+'px'):''}`"
          class="d-flex flex-wrap align-content-between"
        >
          <div
            style="
              color: #212529;
              width: 100%;
              font-weight: 600;
              font-size: 16px;
            "
          >
          <img
            style="position: absolute;width: 635px;
              height: 545px;
              top: -160px;"
              src="../../assets/images/examination/LooperGroup_2x.png"
              alt=""
          />
            <img
              style="width: 20px; height: 20px"
              src="../../assets/images/examination/vector2.png"
              alt=""
            />
            知识库建议
          </div>
          <div
            style="
              position: absolute;
              top: 20px;
              background: transparent;
              border: 0.5px solid #dde4f0;
              box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
              border-radius: 20px;
            "
            class="w-100 h-100 p-4 mt-2"
          >
            <p style="
                color: #31A6E8;
                font-size: 13px;
                font-weight: 500;
                line-height: 19.5px;
            ">故障原因</p>
            <ul
              :style="`
                line-height: 30px;
                font-weight: 400;
                font-size: 16px;
                color: #212529;
                ${isPrint?'max-height: 60px;overflow: auto;':''}
              `"
            >
              <li v-for="(reason, index) in risk_prediction_desc.fault_reason" :key="index">{{ reason }}</li>
            </ul>
            <p style="
                color: #31A6E8;
                font-size: 13px;
                font-weight: 500;
                line-height: 19.5px;
            ">解决方案</p>
            <ul
              :style="`
                  line-height: 30px;
                  font-weight: 400;
                  font-size: 16px;
                  color: #212529;
                  ${isPrint?'max-height: 60px;overflow: auto;':''}
                `"
            >
              <li v-for="(solution, index) in risk_prediction_desc.solution" :key="index">{{ solution }}</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
    <!-- 测点历史echart -->
    <div class="card">
      <div
        class="card-header border-0 d-flex justify-content-between"
        style="font-weight: 600; font-size: 16px; color: #212529"
      >
        <div>
          <img
              style="height: 27px; width: 27px"
              src="../../assets/images/examination/vector3.png"
              alt=""
          />
          测点历史趋势
        </div>
      <div class="d-flex justify-content-between cursor-pointer" style="width:130px">
        <div @click="filterMoment('1')" :class="`yr ${ currentYR == 1?'yr_action':'' }`">1YR</div>
        <div @click="filterMoment('3')" :class="`yr ${ currentYR == 3?'yr_action':'' }`">3YR</div>
        <div @click="filterMoment('6')" :class="`yr ${ currentYR == 6?'yr_action':'' }`">6YR</div>
      </div>


      </div>
      <div style="min-height: 350px" class="card-body position-relative">
        <div
          class="me-4"
          style="
            width: 23px;
            height: 23px;
           background: rgba(102, 145, 231, 0.2);
            mix-blend-mode: normal;
            border-radius: 8px;
            text-align: center;
            line-height: 23px;
            cursor: pointer;
            position: absolute;
            left: 20px;
            top: 50%;
          "
          v-if="statisticsPage > 1"
        >
          <i
            class="ri-arrow-left-s-line"
            @click="
              () => {
                if (statisticsPage > 1) {
                  statisticsPage -= 1;
                }
              }
            "
          ></i>
        </div>
        <div
          class="ms-4"
          style="
            width: 23px;
            height: 23px;
            background: rgba(102, 145, 231, 0.2);
            border-radius: 8px;
            text-align: center;
            line-height: 23px;
            cursor: pointer;
            position: absolute;
            right: 20px;
            top: 50%;
          "
          v-if="statistics.data && statistics.data.length > 5"
        >
          <i
            class="ri-arrow-right-s-line"
            @click="
              () => {
                if (
                  statistics &&
                  statistics.data.length > 5 &&
                  statisticsPage <= statistics.data.length / 6
                ) {
                  statisticsPage += 1;
                }
              }
            "
          ></i>
        </div>
        <div
          v-if="statistics && !statistics.enabled && !equip_data.is_iot_ready"
          style="
            width: 100%;
            height: 100%;
            min-height: 360px;
            background: rgba(73, 87, 135, 0.4);
            position: absolute;
            top: 0;
            left: 0;
            backdrop-filter: blur(10px);
            z-index: 10;
          "
          class="d-flex justify-content-center align-items-center"
        >
          <div
            style="
              width: 454px;
              height: 86px;
              line-height: 86px;
              text-align: center;
              background: rgba(67, 82, 133, 0.8);
              box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
              border-radius: 20px;
              font-weight: 600;
              font-size: 32px;
              color: #ffffff;
            "
          >
            请开通IoT功能
          </div>
        </div>
        <div class="d-flex">
          <div
            v-for="(item, index) in statisticsList"
            :key="index"
            :style="{
              padding: '0 20px',
              borderRight: index == 3 ? 'none' : '1px dashed #c3cbcf',
              width: '25%',
            }"
          >
            <div
              style="
                font-weight: 400;
                font-size: 16px;
                color: #212529;
                padding-left: 20px;
              "
            >
              <img
                :src="item.icon"
                :style="item.iconStyle"
                alt=""
              />
              {{ item.title }}
            </div>
            <div
              :id="'statisticsChart' + (index + 1)"
              style="width: 100%; height: 260px"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务建议 -->
    <div class="card">
      <div
        class="card-header border-0"
        style="font-weight: 600; font-size: 16px; color: #212529; padding-bottom: 0;"
      >
        <img
          style="height: 27px; width: 27px"
          src="../../assets/images/examination/vector4.png"
          alt=""
        />
        服务建议
      </div>
      <div
        style="min-height: 350px"
        class="card-body"
      >
        <div class="me-2 ms-2">
        <template v-for="(items, key) in maintenanceSuggestionTable" :key="key">
          <div class="d-flex align-items-center mb-4">
            <div><img src="../../assets/images/examination/icon.svg" /></div>
            <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{ SERVICE_TYPE_MAP[key] }}</div>
          </div>
          <div :class="[
              'table-responsive',
              'table-card',
              'mb-1 me-2 ms-2',
              'table-page-responsive',
              'table-ellipsis',
            ]"
          > 
          <template v-if="key == '1'">
              <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                <thead class="text-muted table-light">
                <tr class="text-uppercase">
                  <th>故障表现</th>
                  <th>维保建议</th>
                </tr>
                </thead>
                <tbody class="list form-check-all">
                  <template v-for="(a, fault_name) in items" :key="'Service'+fault_name">
                  <tr v-for="(item, i) in a" :key="'Service'+fault_name + i">
                    <td :rowspan="1">{{ fault_name }}</td>
                    <td :rowspan="1">
                      <div class="mt-1 mb-1" v-for="itemName in item['data']&&item['data']['suggestionList']" :key="itemName">
                        <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                          <ellipse cx="4.51639" cy="4" rx="3.9866" ry="4" fill="#6691E7"/>
                        </svg>
                        {{ itemName }}
                      </div>
                    </td>
                  </tr>
                  </template>
                </tbody>
              </table>
          </template>
          <template v-else-if="key == '2'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th class="text-center">配件建议</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <template v-for="(a, fault_name) in items" :key="'spare'+fault_name">
              <tr v-for="(item, i) in a" :key="'spare'+fault_name + i">
                <td :rowspan="1">
                  {{fault_name}}
                </td>
                <td  :rowspan="1" style="padding:0;">
                  <table v-if="item.data.partsList&&item.data.partsList.length>0" class="table table-bordered table-striped table-nowrap w-100" style="margin-bottom:0;">
                    <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <th scope="col" class="text-center">规格</th>
                      <th scope="col" class="text-center">用量</th>
                      <th scope="col" class="text-center">位号</th>
                      <th scope="col">台用量</th>
                      <th scope="col">名称</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(b,j) in item.data.partsList" :key="b.id">
                      <td scope="row" class="text-center" style="vertical-align: middle;background-color:none" v-if="j==0" :rowspan="item.data.partsList.length">
                        {{ {'1':'大修','2':'中修','3':'小修'}[item.data.attachmentLevel]}}
                      </td>
                      <td scope="row" class="text-center" style="vertical-align: middle;background-color:none" v-if="j==0" :rowspan="item.data.partsList.length">
                        {{1}}台*{{item.data.attachmentNum}}
                      </td>
                      <td scope="row" class="text-center">{{b.location}}</td>
                      <td>{{b.quantity}}</td>
                      <td>
                        <el-popover
                            v-if="b.name==='维修包'"
                            placement="left"
                            :width="700"
                            trigger="click"
                            :teleported="false"
                        >
                          <template #reference>
                            <div style="text-decoration:underline;cursor: pointer;width:50px">{{ b.name }}</div>
                          </template>
                          <el-table height="300" :data="b.extra_info">
                            <el-table-column width="300"  property="desc" label="GDNC描述" />
                            <el-table-column  property="quantity" label="数量" />
                            <el-table-column  property="unit" label="单位" />
                            <el-table-column  property="location" label="位号" />
                          </el-table>
                        </el-popover>
                        <div v-else>
                          {{ b.name }}
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              </template>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '3'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <template v-for="(a, fault_name) in items" :key="'Up'+fault_name">
              <tr v-for="(item, i) in a" :key="'Up'+fault_name + i">
                <td>{{ fault_name }}</td>
                <td>{{ item.remark }}</td>
              </tr>
              </template>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '4'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>Care类型</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <template v-for="(a, fault_name) in items" :key="'Care'+fault_name">
              <tr v-for="(item, i) in a" :key="'Care' + fault_name + i">
                <td>
                  {{ fault_name }}
                </td>
                <td>
                  {{ item.data.careModel }}
                </td>
                <td>
                  {{ item.remark }}
                </td>
              </tr>
              </template>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '5'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <template v-for="(a, fault_name) in items" :key="'Repair'+fault_name">
              <tr v-for="(item, i) in a" :key="'Repair' + fault_name + i">
                <td>
                  {{ fault_name }}
                </td>
                <td>
                  {{ item.remark }}
                </td>
              </tr>
              </template>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '6'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <template v-for="(a, fault_name) in items" :key="'Replacement'+fault_name">
              <tr v-for="(item, i) in a" :key="'Replacement' + fault_name + i">
                <td>
                  {{ fault_name }}
                </td>
                <td>
                  {{ item.remark }}
                </td>
              </tr>
              </template>
              </tbody>
            </table>
          </template>
          </div>
        </template>
        </div>
      </div>
    </div>
    <!-- 体检项记录 -->
    <div class="card">
      <div style="min-height: 350px" class="card-body d-flex position-relative">
        <div
          v-if="realtime_data && !realtime_data.enabled && !equip_data.is_iot_ready"
          style="
            width: 100%;
            height: 100%;
            min-height: 360px;
            background: rgba(73, 87, 135, 0.4);
            position: absolute;
            top: 0;
            left: 0;
            backdrop-filter: blur(10px);
            z-index: 10;
          "
          class="d-flex justify-content-center align-items-center"
        >
          <div
            style="
              width: 454px;
              height: 86px;
              line-height: 86px;
              text-align: center;
              background: rgba(67, 82, 133, 0.8);
              box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
              border-radius: 20px;
              font-weight: 600;
              font-size: 32px;
              color: #ffffff;
            "
          >
            请开通IoT功能
          </div>
        </div>
        <div style="width: 100%; padding: 0px 10px;">
          <img src="../../assets/images/examination/nash_cert.png" style="height: 384px;width: 401px;position: absolute;left: 60%;">
          <div class="d-flex align-items-center">
            <div>
              <img
                style="height: 27px; width: 27px"
                src="../../assets/images/examination/vector3.png"
                alt=""
              />
            </div>
            <div class="ms-2 mb-2">
              <div style="font-weight: 600; font-size: 16px; color: #212529">
                体检项记录
              </div>
              <div style="font-weight: 400; font-size: 12px; color: #304350">
                检测时间 {{ report_data && report_data.report_date }}
              </div>
            </div>
          </div>

          <table class="table table-hover align-middle mt-2">
            <thead class="table-light">
              <tr>
                <th>检测点</th>
                <th>检测值</th>
              </tr>
            </thead>
            <tbody class="list">
              <tr v-for="a in realtime_data.data" :key="a.id">
                <td>
                  <!-- <img
                    class="me-2"
                    style="height: 17px; width: 17px"
                    :src="statusImage[a.status]"
                    alt=""
                  /> -->
                  <span
                      :class="`status-icon me-1 status-icon-${statusImage[a.status]}`"
                          style="
                          padding: 8px 15px;
                          width: 20px;
                          height: 20px;
                          background-size: 20px 20px;
                        "
                      ></span>
                  {{ a.key }}
                </td>
                <!-- 测点值/单位 -->
                <td>{{ a.value }} {{ AUDITING_MEASUREMENT_UNIT_MAP[a.key]?AUDITING_MEASUREMENT_UNIT_MAP[a.key]:'' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 异常事件 -->
    <div class="card">
      <div
        class="card-header border-0"
        style="font-weight: 600; font-size: 16px; color: #212529"
      >
        <img
          style="height: 27px; width: 27px"
          src="../../assets/images/examination/file5.png"
          alt=""
        />
        异常事件记录
      </div>
      <div style="min-height: 350px" class="card-body position-relative">
        <div
          v-if="realtime_data && !realtime_data.enabled && !equip_data.is_iot_ready"
          style="
            width: 100%;
            height: 100%;
            min-height: 360px;
            background: rgba(73, 87, 135, 0.4);
            position: absolute;
            top: 0;
            left: 0;
            backdrop-filter: blur(10px);
            z-index: 10;
          "
          class="d-flex justify-content-center align-items-center"
        >
          <div
            style="
              width: 454px;
              height: 86px;
              line-height: 86px;
              text-align: center;
              background: rgba(67, 82, 133, 0.8);
              box-shadow: 0px 2px 1px rgba(64, 72, 82, 0.1);
              border-radius: 20px;
              font-weight: 600;
              font-size: 32px;
              color: #ffffff;
            "
          >
            请开通IoT功能
          </div>
        </div>
        <table class="table table-hover align-middle mt-2">
          <thead class="table-light">
            <tr>
              <th>事件描述</th>
              <th>发生时间</th>
              <th>故障原因分析及建议</th>
              <th>相关工艺说明</th>
            </tr>
          </thead>
          <tbody class="list">
            <tr v-for="a in eventsList" :key="a.created_at">
              <td>
                <img
                  src="@/assets/images/eventtype-warning.svg"
                  style="
                    width: auto;
                    height: auto;
                    margin-bottom: 4px;
                    margin-right: 5px;
                  "
                  v-if="a.level === 'WARNING'"
                 alt="#"/>
                <img
                  src="@/assets/images/eventtype-error.svg"
                  style="
                    width: auto;
                    height: auto;
                    margin-bottom: 4px;
                    margin-right: 5px;
                  "
                  v-if="a.level === 'ERROR'"
                 alt="#"/>
                <img
                  src="@/assets/images/eventtype-alarm.svg"
                  style="
                    width: auto;
                    height: auto;
                    margin-bottom: 4px;
                    margin-right: 5px;
                  "
                  v-if="
                    a.level === 'WARNING' &&
                    a.kind == 'TIME_BASED_DYTHRESHOLD_PREDICATE'
                  "
                 alt="#"/>
                <img
                  src="@/assets/images/eventtype-remind.svg"
                  style="
                    width: auto;
                    height: auto;
                    margin-bottom: 4px;
                    margin-right: 5px;
                  "
                  v-if="a.level === 'NORMAL'"
                 alt="#"/>
                <img
                  src="@/assets/images/eventtype-unknown.svg"
                  style="
                    width: auto;
                    height: auto;
                    margin-bottom: 4px;
                    margin-right: 5px;
                  "
                  v-if="a.level === 'UNKNOWN'"
                 alt="#"/>{{ a.title }}
              </td>
              <td>
                {{ moment(a.created_at).format("YYYY年MM月DD日 HH:mm:ss") }}
              </td>
              <td>
                {{ a.failure_analysis }}
              </td>
              <td>
                {{ a.process_desc }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 打印按钮 -->
    <div v-if="isPrint" class="d-flex align-content-center justify-content-end" style="margin:50px 0;">
      <button type="button" class="btn btn-success custom-toggle" data-bs-toggle="button" @click="toPrint">
          <span class="icon-on"><i class="ri-printer-line me-1"></i> 打印</span>
      </button>
    </div>
    <!-- <b-card v-show="false">
      <b-card-header class="fs-14 fw-bold d-flex justify-content-between ps-0 pt-0">
        <div class="d-flex align-items-center">
          <img
            style="height: 27px; width: 27px"
            src="../../assets/images/examination/vector4.png"
            alt=""
          />
          <div style="font-weight: 600; font-size: 16px; color: #212529" class="me-1">服务建议</div>
        </div>
      </b-card-header>
      <b-card-body>
        <template v-for="(items, key) in maintenanceSuggestionTable" :key="key">
          <div class="d-flex align-items-center mb-4">
            <div><img src="../../assets/images/examination/icon.svg" /></div>
            <div class="ms-1" style="color:#9599AD;font-size: 12px;font-weight: 500;">{{ SERVICE_TYPE_MAP[key] }}</div>
          </div>
          <div :class="[
              'table-responsive',
              'table-card',
              'mb-1 me-2 ms-2',
              'table-page-responsive',
              'table-ellipsis',
            ]"
          > 
          <template v-if="key == '1'">
              <table class="table table-bordered table-nowrap align-middle" id="orderTable">
                <thead class="text-muted table-light">
                <tr class="text-uppercase">
                  <th>故障表现</th>
                  <th>维保建议</th>
                </tr>
                </thead>
                <tbody class="list form-check-all">
                  <template v-for="(a, fault_name) in items" :key="'Service'+fault_name">
                  <tr v-for="(item, i) in a" :key="'Service'+fault_name + i">
                    <td :rowspan="1">{{ fault_name }}</td>
                    <td :rowspan="1">
                      <div class="mt-1 mb-1" v-for="a in item['data']&&item['data']['suggestionList']" :key="a"><svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                        <ellipse cx="4.51639" cy="4" rx="3.9866" ry="4" fill="#6691E7"/>
                      </svg>{{a}}</div>
                    </td>
                  </tr>
                  </template>
                </tbody>
              </table>
          </template>
          <template v-else-if="key == '2'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>配件建议</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
                <template v-for="(a, fault_name) in items" :key="'spare'+fault_name">
                <tr v-for="(item, i) in a" :key="'spare'+fault_name + i">
                  <td :rowspan="1">
                    <div class="d-flex">
                      <div>{{fault_name}}</div>
                      <div class="ms-5">{{ {'1':'大修','2':'中修','3':'小修'}[item.data.attachmentLevel]}}</div>
                      <div class="ms-2">{{1}}台*{{item.data.attachmentNum}}</div>
                    </div>
                  </td>
                  <td  :rowspan="1">
                    <table v-if="item.data.partsList&&item.data.partsList.length>0" class="table table-bordered table-striped table-nowrap w-100">
                      <thead class="text-muted table-light">
                      <tr class="text-uppercase">
                        <th scope="col">位号</th>
                        <th scope="col">台用量</th>
                        <th scope="col">名称</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="b in item.data.partsList" :key="b.id">
                        <th scope="row">{{b.location}}</th>
                        <td>{{b.quantity}}</td>
                        <td>
                          <el-popover
                              v-if="b.name==='维修包'"
                              placement="right"
                              :width="400"
                              trigger="click"
                              :teleported="false"
                          >
                            <template #reference>
                              <div style="text-decoration:underline;cursor: pointer;width:50px">{{ b.name }}</div>
                            </template>
                            <el-table height="300" :data="b.extra_info">
                              <el-table-column  property="desc" label="GDNC描述" />
                              <el-table-column  property="quantity" label="数量" />
                              <el-table-column  property="unit" label="单位" />
                              <el-table-column  property="location" label="位号" />
                            </el-table>
                          </el-popover>
                          <div v-else>
                            {{ b.name }}
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                </template>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '3'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, fault_name) in items" :key="key + fault_name">
                <td>
                  <span>{{ fault_name }}</span>
                </td>
              </tr>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '4'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>Care类型</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
              <tr v-for="(item, fault_name) in items" :key="'Care' + fault_name">
                <template
                    v-for="a in item"
                    :key="a.data.remark"
                >
                  <td>
                    {{ fault_name }}
                  </td>
                  <td>
                    {{ a.data.careModel }}
                  </td>
                  <td>
                    {{ a.remark }}
                  </td>
                </template>
              </tr>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '5'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
                <tr v-for="(item, fault_name) in items" :key="'Repair' + fault_name">
                  <template
                      v-for="a in item"
                      :key="a.remark"
                  >
                    <td>
                      {{ fault_name }}
                    </td>
                    <td>
                      {{ a.remark }}
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else-if="key == '6'">
            <table class="table table-bordered table-nowrap align-middle" id="orderTable">
              <thead class="text-muted table-light">
              <tr class="text-uppercase">
                <th>故障表现</th>
                <th>备注</th>
              </tr>
              </thead>
              <tbody class="list form-check-all">
                <tr v-for="(item, fault_name) in items" :key="'Replacement' + fault_name">
                  <template
                      v-for="a in item"
                      :key="a.remark"
                  >
                    <td>
                      {{ fault_name }}
                    </td>
                    <td>
                      {{ a.remark }}
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </template>
          </div>
        </template>
      </b-card-body>
    </b-card> -->
  </div>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@/default.scss";
/* 月年日历插件 */ 
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

import {
  examinationChat,
  statisticsChart,
  standardChart,
  markChart,
} from "@/utils/chart.js";
// import { alertError,alertErrors } from "@/helpers/swal";
// getReportLatest
// postReportLatest
import { getReportList } from "@/service/index.js";
import _ from "lodash";
import moment from "moment";
import eventListPlugin from "@/utils/flatpickrEventList.js";
import { SERVICE_TYPE_MAP,AUDITING_MEASUREMENT_UNIT_MAP } from "@/config/common";
import { WO_OODT_ASSETS } from '@/config/common';


/* html保存pdf*/ 
// import {  htmlPdf } from "@/utils/htmlToPdf";
import Swal from "sweetalert2";
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {
  props: ["examinationWidth","equip_data"],
  page: {
    title: "体检报告",
    meta: [{ tag: 0, name: "description", content: "体检报告" }],
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      SERVICE_TYPE_MAP,
      AUDITING_MEASUREMENT_UNIT_MAP, //测点列表
      maintenanceSuggestionTable:[],
      tableHeadersMaintenanceSuggestion: [
        {
          name: "number",
          label: "设备",
          visible: true,
        },
        {
          name: "type",
          label: "故障表现",
          visible: true,
        },
        {
          name: "types",
          label: "维保建议",
          visible: true,
        }
      ],
      sparePartsList:[],
      tableHeadersSpareParts: [
        {
          name: "number",
          label: "设备",
          visible: true,
        },
        {
          name: "type",
          label: "故障表现",
          visible: true,
        },
        {
          name: "types",
          label: "配件建议",
          visible: true,
        }
      ],
      upgradingList:[],
      tableHeadersUpgrading: [
        {
          name: "devices",
          label: "设备",
          visible: true,
        },
        {
          name: "remark",
          label: "故障表现",
          visible: true,
        }
      ],
      current_tab: 0,
      MaintenanceIndex: [
        { title: "一级保养" },
        { title: "二级保养" },
        { title: "返厂大修" },
      ],
      tabInfo: [
        {
          tab_name: "未达标指标",
          href: "Actual",
          list: [],
          imgUrl: require("../../assets/images/examination/error.png"),
          status: "",
          statusText: "已超出标准区间，需要注意。",
        },
        {
          tab_name: "需要关注指标",
          href: "Original",
          list: [],
          imgUrl: require("../../assets/images/examination/error.png"),
          status: "",
          statusText: "已超出标准区间，需要注意。",
        },
        {
          tab_name: "健康指标",
          href: "Standard",
          list: [],
          imgUrl: require("../../assets/images/examination/heathly.png"),
          status: "",
          statusText: "在标准区间。",
        },
      ],
      selectedMonth: '',  
      engineer_info: {
        company: "",
        name: "",
        tel: "",
        email: "",
      },
      statistics: {},
      risk_prediction_desc: {},
      eventsList: [],
      realtime_data: {},
      risk_prediction: {},
      maintain: {},
      realtimePage: 1,
      realtimePerPage: 6,
      statisticsPage: 1,
      statisticsPerPage: 5,
      report_data: {},
      statisticsList: [
        {title: "压力", icon: require("../../assets/images/statistics/pressure.svg"), iconStyle: "width: 20.06px; height: 17.4px;"},
        {title: "温度", icon: require("../../assets/images/statistics/temperature.svg"), iconStyle: "width: 11.93px; height: 25.37px;"},
        {title: "振动", icon: require("../../assets/images/statistics/vibration.svg"), iconStyle: "width: 19.56px; height: 15.91px;"},
        {title: "电流", icon: require("../../assets/images/statistics/current.svg"), iconStyle: "width: 15.99px; height: 16.42px;"},
        // {title: "工作液流量", icon: require("../../assets/images/statistics/flow.svg"), iconStyle: "width: 21px; height: 13px;"},
      ],
      /* 当前测点折线图 */ 
      chartDataList: [],
      statusImage:{
        "1": 'health',
        "2": 'sub-health',
        "3": 'error',
      },
      /* 健康报告数据列表 */ 
      reportList:[],
      indexNum:0,
      /* 当前年份 */ 
      currentYear:null,
      /* 打印状态 */
      isPrint:true,
      /* 当前折线统计图选择多少年*/  
      currentYR:'3',
      splitIndex:0,
      riskPredictionDescLength:0,
    };
  },
  mounted() {
    let that = this
    /* 初始化数据 */
    if (this.examinationWidth > 0) {
      this.getReportLatestData(this.examinationWidth)

    }
    /* 日历控件初始化，绑定监听事件 */ 
    this.$nextTick(() => {
     if(document.getElementsByClassName("flatpickr-calendar")&&document.getElementsByClassName("flatpickr-calendar")[0]){
      document.getElementsByClassName("flatpickr-calendar")[0].id="device_report"
     }
     let dom = document.getElementById('mouthYearFlatPickr')
     if(dom){
       document.getElementById('mouthYearFlatPickr').flatpickr({
         dateFormat:"Y-m", //默认展示日期
         closeOnSelect:false, //设置为false以禁止选择日期后自动关闭选择器 
         plugins:[
           new monthSelectPlugin({
                 shorthand: true, //defaults to false
                 dateFormat: "Y-m", //defaults to "F Y"
                 altFormat: "Y-m", //defaults to "F Y"
                 theme: "light", // defaults to "light"
               }),
           new eventListPlugin({
             text: "demo",
           }),
         ],
         onOpen: function(){
           /* 获取12月的dom节点*/ 
           that.openMouthEvent()
         },
         onChange:function(selectedDates, dateStr){
           that.selectedMonth = dateStr //当前月份
           /* 添加事件状态 */  
           /* 获取当前月份查找出当月是否有健康体检事件 */
           let event_info = {} 
           that.reportList.map((item,index)=>{
             if(item.report_date.includes(dateStr)){
               that.indexNum = index
               event_info = item
               return;
             }
           })
           /* 事件dom赋html*/
           that.addEventHTML(event_info)
           /* 报告发生变化：有数据发生改变，没有不执行 */ 
 
           that.setMarkChart({indexNum:that.indexNum})
           console.log(selectedDates);
         },
         onYearChange:function(selectedDates, dateStr, instance){
           that.currentYear =  instance.currentYear //当前年份发生改变
           that.openMouthEvent()
 
           console.log(selectedDates, dateStr);
         }
       })
     }
    })
  },
  watch: {
    examinationWidth: {
      // immediate:true,
      handler(val) {
        if (val > 0) {
          if(this.reportList[this.indexNum]){
            this.reportDataUpdated(this.reportList[this.indexNum],val)
          }
        }
      },
    },
  },
  methods: {
    /* 日历打开时原点赋值到日历上 */ 
    openMouthEvent(){
      let y = moment().format('YYYY')
      if(this.currentYear){
        y = this.currentYear
      }
      let dayElems = document.getElementsByClassName('flatpickr-monthSelect-month')
      if(dayElems){
            this.reportList.length&&this.reportList.map(item=>{
              /* 获取的是当前年份报告,如果年份切换根据年份渲染 */
              if(item.report_date.includes(y)){ 
                let m = moment(item.report_date).format('M')
                if(m == 1) { //月份对应索引关系，减1
                  m = 0
                }else {
                  m = m - 1
                }
                this.$nextTick(()=>{
                  dayElems[m].innerHTML += `
                    <span class='report event' style="background-color:${this.scoreColor(item.score).color};"></span>
                  `;
                })
              }
            })

          }
    },
    /* 添加dom 事件节点*/
    addEventHTML(event_info){
      /* 获取到日历事件dom，直接赋值当月的数据事件*/ 
      let instanceReportDom = document.getElementById('instanceReport')
      if(instanceReportDom){
        if(event_info){
          instanceReportDom.innerHTML = `
          <div class="d-flex align-items-center">
                              <div class="fs-15" style="width: 45px;height: 45px;
                              color:${this.scoreColor(event_info.score).color};border-radius: 50%;text-align: center;line-height: 45px;
                              background: ${this.scoreColor(event_info.score).rgba};
background-image: repeating-linear-gradient(60deg,hsla(0,0%,100%,0.5),hsla(0,0%,100%,0.5) 15px,transparent 0,transparent 30px);">
                                  ${event_info.score||''}
                              </div>
                              <div style="margin-left:10px;text-align: left;">
                                  <div style="color:#495057;">设备名称：${this.equip_data.name}</div>
                                  <div>服务人员：${event_info.report_data.engineer_info&&event_info.report_data.engineer_info.name}</div>
                              </div>
                          </div>
                          <div style="white-space:nowrap;">${moment(event_info.report_date).format('MM-DD')}</div>
          `
        }else{
          instanceReportDom.innerHTML = `
          <div>暂无</div> 
          `
        }
      }
    },
    moment,
    currentChange(val) {
      this.current_tab = val;
      this.tabInfo[val].list.map((item, index) => {
        this.$nextTick(() => {
          var standardChartDom = document.getElementById(
            "standardChart" + (index + 1)
          );
          standardChart({
            chartDom: standardChartDom,
            measurement_data: item.value,
            status: item.status,
          });
        });
      });
    },

    /* 获取健康报告数据:进入页面初始一次 */ 
    getReportLatestData(val) {
      var data = {};

      let params = {
        instance_id: this.$route.query.equip_id,
      };
      getReportList(params).then((res) => {
        if (res && res.payload) {
          this.reportList = _.cloneDeep(res.payload)
          /* 健康报告详情~默认 */
          this.indexNum =  this.reportList.length - 1
          data = this.reportList[this.reportList.length - 1];

          /* 获取所有报告测点数据 */ 
          
          // this.selectedMonth = moment(data.report_date).format('YYYY-MM') // 设置默认月份
          this.addEventHTML(data) // 添加默认数据dom
          this.inntMakeStatisticsData(this.currentYR)

          this.reportDataUpdated( data, val )
        }
      });
    },
    /* 历史测点数据,刷新echarts数据 */ 
    inntMakeStatisticsData(currentYR){
      /* 当前报告是默认3年的测点数据，需要设置一个默认 */ 
      let measurement_history = this.handleMeasurementList(currentYR)
      if (measurement_history.length > 0) {
        this.statistics = {
          "data": [],
          "enabled": true
        };

        this.chartDataList = this.makeStatisticsData(measurement_history, 1)

        this.$nextTick(() => {
          this.chartDataList.map((item, index) => {
            var statisticsChartDom = document.getElementById(
              "statisticsChart" + (index + 1)
            );

            statisticsChart({
              chartDom: statisticsChartDom,
              chartData: this.combineObjectsByKey(item),
              type:currentYR
            });
          });
        });
      } else {
        this.statistics = {
          "data": [],
          "enabled": false
        }
      }
    },
    /* 数据分配*/ 
    reportDataUpdated(data, width ){
      if(!data) return;
      this.report_data = data
      this.maintain = [];
      // this.statistics = []; //测点历史趋势
      this.eventsList = []; //异常事件记录
      this.realtime_data = []; //异常事件记录 -- 事件描述
      var listDate = []; //日期
      var listData = []; //体检分数
      this.reportList.map((item) => {
        listDate.push(item.report_date);
        listData.push(item.score);
      });
      this.engineer_info = data.report_data.engineer_info;
      /* 柱状图 */ 
      let chartDom = document.getElementById("examinationChat");
      chartDom.style.width = width + "px";
      examinationChat(
        {
          chartDom: chartDom,
          listDate: listDate,
          listData: listData,
          indexNum:this.indexNum,
        },
        this.setMarkChart
      );
      /* 健康评分饼图 */ 
      let markChartDom = document.getElementById("markChart");
      /* 根据健康评分不同等级颜色 */ 

      markChart({
        chartDom: markChartDom,
        markData: {
          data: (data && data.score) || 0,
          score_diff_first: data && data.report_data && data.report_data.score_diff_first,
          score_diff_last: data && data.report_data && data.report_data.score_diff_last,
        },
        score_color:this.scoreColor(data && data.score).color,
      });
      if (data && data.report_data && data.report_data.risk_prediction) {
        
        this.risk_prediction = _.get(
          data,
          ["report_data", "risk_prediction"],
          {}
        );
        if(this.risk_prediction.data.length>1){
         this.splitIndex = Math.ceil(this.risk_prediction.data.length/2) //向上取整，便于故障原因分两侧展示。
        }

        /* 默认展示第一条 */
        let val = _.get(
          data,
          ["report_data", "risk_prediction", "data", "0"],
          ""
        );
        if(val){
          this.risk_prediction_desc = {
            "fault_reason": val.fault_reason.split("\n"),
            "solution": val.solution.split("\n")
          }
          this.riskPredictionDescLength = this.risk_prediction_desc.fault_reason.length +this.risk_prediction_desc.solution.length
        }

      }
      if (data && data.report_data && data.report_data.maintain) {
        this.maintain = data.report_data && data.report_data.maintain;
      }

      this.maintenanceSuggestionTable = data.report_data.service_suggestions

      this.realtime_data = {
        enabled: true,
        data: data.report_data.measurement_list
      }

      if (data && data.report_data && data.report_data.events) {
        this.eventsList = data.report_data && data.report_data.events.data;
      }


    },
    /* 获取测点列表 */ 
    handleMeasurementList(currentYR){
      let reslut = [],
          year_list = this.getYear(currentYR);
      this.reportList&&this.reportList.map(report=>{
        if(report.report_data&&report.report_data.measurement_history){
          /* 筛选当前年份往前推几年的历史测点数据 */
          let year = moment(report.report_date).format('YYYY') 
          if(year_list.some(y=>y == year)){
            reslut.push(...report.report_data.measurement_history)
          }
        }
      })
      return reslut;
    },
    /* 体检分数颜色分类 */ 
    scoreColor(score){
      let color = '#F74B4B',
          rgba = 'rgba(247, 75, 75, 0.2)'
      if(score > 90 || score == 90){ //健康
        color = '#35B775'
        rgba = 'rgba(53, 183, 117, 0.2)'
      }else if((score > 60|| score == 60) && score < 90){ //亚健康
        color = '#F7B84B'
        rgba = 'rgba(247, 184, 75, 0.2)'
      }else if((score > 30|| score == 30) && score < 60){//异常
        color = '#ED5E5E'
        rgba = 'rgba(237, 94, 94, 0.2)'
      }else{ //危险
        color = '#F74B4B'
        rgba = 'rgba(247, 75, 75, 0.2)'
      }
      return {color,rgba};
    },
    /* 点击年份筛选数据的时间段1年，3年，6年 */ 
    filterMoment(type){
      this.currentYR = type
      this.inntMakeStatisticsData(type)
      // this.chartDataList.map((item, index) => {
      //   var statisticsChartDom = document.getElementById(
      //       "statisticsChart" + (index + 1)
      //   );
      //   statisticsChart({
      //     chartDom: statisticsChartDom,
      //     chartData: item,
      //     type:type
      //   });
      // });
    },
    /* 柱状图的点击回调 */ 
    setMarkChart(option) {
      /* 数据更改了 */ 
      this.indexNum = option.indexNum
      if(this.reportList[option.indexNum]){
        this.reportDataUpdated(this.reportList[option.indexNum],this.examinationWidth)
      } //不执行数据

    },
    /* 日历控件清除按钮 */ 
    clearDate() {
      this.selectedMonth = ''
    },
    selectFaultHandler(val) {
      this.risk_prediction_desc = {
        "fault_reason": val.fault_reason.split("\n"),
        "solution": val.solution.split("\n")
      }
      this.riskPredictionDescLength = this.risk_prediction_desc.fault_reason.length +this.risk_prediction_desc.solution.length
    },
    makeStatisticsData(source, range) {
      console.log(range)
      const key_map = {
        "压力": 0,
        "温度": 1,
        "振动": 2,
        "电流": 3,
        // "流量": 4
      }
      let result = [
        [],
        [],
        [],
        [],

      ]
      let cache = {}
      for(let i = 0; i < source.length; i++) {
        let item = source[i]
        let index = -1
        console.log(range)

        if (item.key in cache) {
          index = cache[item.key]
        } else {
          for (let key in key_map) {
            if (item.key.indexOf(key) !== -1) {
              cache[item.key] = key_map[key]
              index = cache[item.key]
              break
            }
          }
        }

        if (index == -1) continue
        result[index].push(item)
      }
      return result
    },
    /* 设备分类不同的img */ 
    equipImage(){
      const baseURL = _.trimEnd(_.trim(WO_OODT_ASSETS, '"'), "/")

      let img = `${baseURL}/oodt-assets/device-report/report_other.gif` //默认img
      if(this.equip_data&&this.equip_data.extra_info){
        if(JSON.stringify(this.equip_data.extra_info.product_list).includes('风机')){
          img = `${baseURL}/oodt-assets/device-report/report_ventilator.png`
        }else if(JSON.stringify(this.equip_data.extra_info.product_list).includes('干泵')){
          img = `${baseURL}/oodt-assets/device-report/report_pump.png`
        }
      }
      return img;
    },
    toPrint(){
      this.isPrint = false
      Swal.fire({
        title: "打印中",
        showConfirmButton: false,
      });
      Swal.showLoading();
      this.$nextTick(()=>{
        try{
          // 确保页面渲染完毕
          setTimeout(() => {
            this.getPdf(`${this.equip_data.name}设备健康体检报告`,
                document.querySelector("#printJS-form"),
                277
            )

          }, 1000)
        }catch(e){
          this.isPrint = true
          throw new Error(e)
        }
      })
    },
    getPdf(title, html, h=220) {
        html2Canvas(html, {
            allowTaint: false,
            taintTest: false,
            logging: false,
            useCORS: true,
            dpi: window.devicePixelRatio * 4, // 将分辨率提高到特定的DPI 提高四倍
            scale: 4, // 按比例增加分辨率
        }).then((canvas) => {
            const pdf = new JsPDF('p', 'mm', 'a4') // A4纸，纵向
            const ctx = canvas.getContext('2d')
            const a4w = 190
            const a4h = h// A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
            const imgHeight = Math.floor((a4h * canvas.width) / a4w) // 按A4显示比例换算一页图像的像素高度
            let renderedHeight = 0
            while (renderedHeight < canvas.height) {
                const page = document.createElement('canvas')
                page.width = canvas.width
                page.height = Math.min(imgHeight, canvas.height - renderedHeight)

                // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
                page
                    .getContext('2d')
                    .putImageData(
                        ctx.getImageData(
                            0,
                            renderedHeight,
                            canvas.width,
                            Math.min(imgHeight, canvas.height - renderedHeight)
                        ),
                        0,
                        0
                    )
                pdf.addImage(
                    page.toDataURL('image/jpeg', 1.0),
                    'JPEG',
                    10,
                    10,
                    a4w,
                    Math.min(a4h, (a4w * page.height) / page.width)
                ) // 添加图像到页面，保留10mm边距

                renderedHeight += imgHeight
                if (renderedHeight < canvas.height) {
                    pdf.addPage() // 如果后面还有内容，添加一个空页
                }
                // delete page;
            }
            Swal.close();
            // 保存文件
            pdf.save(`${title}.pdf`)
            this.isPrint = true
            
        }).catch(()=>{ //失败回调
          Swal.close();
          this.isPrint = true
        })
    },
    /* 打印fpd文件 */
    // toPrint(){
    //   this.isPrint = false
    //   Swal.fire({
    //     title: "打印中",
    //     showConfirmButton: false,
    //   });
    //   Swal.showLoading();
    //   this.$nextTick(()=>{
    //     try{
    //       // 确保页面渲染完毕
    //       setTimeout(() => {
    //         htmlPdf.getPdf(`${this.equip_data.name}设备健康体检报告`,
    //             document.querySelector("#printJS-form"),
    //             277
    //         )
    //         Swal.close();
    //         this.isPrint = true
    //       }, 1000)
    //     }catch(e){
    //       this.isPrint = true
    //       throw new Error(e)
    //     }
    //   })
    // }, 

    /* 获取指定年开始到现在年的数组 */ 
    getYear(currentYR){
      //获取到从那一年开始
      let yearList = [];
      //获取当前时间
      let date = new Date();
      let nowYears = date.getFullYear();
      var Years = currentYR;
      let arrYear = [];
      for (let i = 1; i <= Years; i++) {
        arrYear.push(nowYears--);
      }
      arrYear.forEach((ele) => {
        yearList.push(ele);
      });
      return yearList
    },
    /* 组合同类名状态下data */ 
    combineObjectsByKey(array) {  
      // 创建一个空对象，用于存储组合后的结果  
      const combined = {};  

      // 遍历输入数组  
      array.forEach(item => {  
        // 检查当前key是否已经在combined对象中  
        if (!combined[item.key]) {  
          // 如果不在，就创建一个新的数组来存储data  
          combined[item.key] = { ...item };  
        } else {  

          // 如果已经在，就将当前item的data添加到已有的数组中  
          combined[item.key].data = combined[item.key].data.concat(item.data);  
        }  
      });  

      // 将combined对象的值转换回数组  
      return Object.values(combined);  
    },
  },
  computed: {
    tabInfoList() {
      var orders = this.tabInfo[this.current_tab].list || [];
      let page = this.realtimePage;
      let perPage = this.realtimePerPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return orders.slice(from, to);
    },
    // statisticsList() {
    //   var orders = this.statistics.data || [];
    //   let page = this.statisticsPage;
    //   let perPage = this.statisticsPerPage;
    //   let from = page * perPage - perPage;
    //   let to = page * perPage;
    //   return orders.slice(from, to);
    // },
  },

};
</script>
<style scoped>
.bgMaintenance0 {
  background: #59d395 !important;
}
.bgMaintenance1 {
  background: #3fc581 !important;
}
</style>
<style>
#device_report.flatpickr-calendar{
  width: 511px !important;
}
#device_report.flatpickr-calendar .flatpickr-days{
  width: 511px !important;
}
#device_report.flatpickr-calendar .dayContainer{
  width: 511px !important;
  max-width: 511px !important;
}
#device_report.flatpickr-calendar .flatpickr-day{
  max-width: 73px !important;
}
.report.event {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 150px;
  bottom: 0px;
  left: calc(50% - 2.5px);
  content: " ";
  display: block;
  background: #13C56B;
}
.report.event.warn {
  background: #F7B84B;
}
.report.event.error {
  background: #F74B4B;
}
/* 日历控件下拉框 */
.flatpickr-calendar.animate.open{
  min-width: 350px;
}
.yr{
  width: 38px;height: 27px;
  border-radius: 4px;
  background: rgba(27, 26, 28, 0.1);
  color: #865CE2;
  font-size: 12px;
  text-align: center;
  line-height: 27px
}
.yr_action{
  background: rgba(102, 145, 231, 0.10) !important;
  color: #6691E7 !important;
}
.tableTitle tr{
  border:none;
  overflow-y: scroll;
}
.scroll-hidden{
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.scroll-hidden::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
</style>